// src/hooks/useInboxStatus.ts
import { useEffect, useState } from 'react';
import { SeenStatus, useListInboxInvitesQuery, useListPlaydateInvitesQuery, User } from '../../gql/types';
import { InboxConnection } from '../inbox/types';

export function useInboxStatus(user?: User) {
    const [hasUnseenRequestUpdates, setHasUnseenRequestUpdates] = useState(false);
    const [precomputedInboxConnection, setPrecomputedInboxConnection] = useState<InboxConnection | undefined>(undefined);

    const { data, loading: inboxLoading } = useListInboxInvitesQuery({
        variables: {
            guestID: user?.id || '',
            seenState: SeenStatus.New,
            since: null,
            limit: 10,
            cursor: null,
        },
        skip: !user,
        fetchPolicy: 'network-only',
    });

    const { data: outgoingData, loading: outgoingLoading } = useListPlaydateInvitesQuery({
        variables: {
            organizerID: user?.id || '',
            seenState: SeenStatus.New,
            since: null,
            limit: 10,
            cursor: null,
        },
        skip: !user,
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (inboxLoading || outgoingLoading) return;

        let hasUnseenUpdates = false;
        let currentConnections: InboxConnection = precomputedInboxConnection || {};

        if (data?.listInboxInvites?.edges?.length) {
            hasUnseenUpdates = true;
            currentConnections = {
                ...currentConnections,
                Inbound: {
                    ...currentConnections.Inbound,
                    Playdate: data.listInboxInvites,
                },
            };
        }

        if (outgoingData?.listPlaydateInvites?.edges?.length) {
            hasUnseenUpdates = true;
            currentConnections = {
                ...currentConnections,
                Outbound: {
                    ...currentConnections.Outbound,
                    Playdate: outgoingData.listPlaydateInvites,
                },
            };
        }

        if (
            JSON.stringify(currentConnections) !== JSON.stringify(precomputedInboxConnection) ||
            hasUnseenUpdates !== hasUnseenRequestUpdates
        ) {
            setPrecomputedInboxConnection(currentConnections);
            setHasUnseenRequestUpdates(hasUnseenUpdates);
        }
    }, [data, outgoingData]);

    return {
        hasUnseenRequestUpdates,
        precomputedInboxConnection,
    };
}
